import { render, staticRenderFns } from "./Nif.vue?vue&type=template&id=3705f6f3"
import script from "./Nif.vue?vue&type=script&lang=ts"
export * from "./Nif.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports